module.exports = __webpack_public_path__ + "img/Ainsley Maitland-Niles.5c52ce2d.png";